<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-tabs v-model="tab">
            <v-tab>Backoffice</v-tab>
            <v-tab>FTP</v-tab>
          </v-tabs>
        </v-toolbar>
      </v-col>
    </v-row>
    <div>
      <v-tabs-items v-model="tab" style="background-color:transparent">
        <v-tab-item>
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="searchBackoffice" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headersBackoffice"
                  :items="getDomains | covertToArray()"
                  sort-by="domain"
                  class="elevation-1"
                  :search="searchBackoffice"
                >
                  <template v-slot:item.domain="{ item }">
                    <span class="pointer-cursor" @click="doCopy($event)">{{ item.domain }}</span>
                  </template>

                  <template v-slot:item.backoffice.url="{ item }">
                    <span class="pointer-cursor" @click="openNew($event)">
                      {{
                      item.backoffice.url
                      }}
                    </span>
                  </template>

                  <template v-slot:item.backoffice.user="{ item }">
                    <span class="pointer-cursor" @click="doCopy($event)">
                      {{
                      item.backoffice.user
                      }}
                    </span>
                  </template>

                  <template v-slot:item.backoffice.password="{ item }">
                    <span class="pointer-cursor" @click="doCopy($event)">
                      {{
                      item.backoffice.password
                      }}
                    </span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn class="ma-2" outlined x-small fab @click="editDomainPopUp(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="searchFtp" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headersFtp"
                  :items="getDomains | covertToArray()"
                  sort-by="domain"
                  class="elevation-1"
                  :search="searchFtp"
                >
                  <template v-slot:item.domain="{ item }">
                    <span @click="doCopy($event)">{{ item.domain }}</span>
                  </template>

                  <template v-slot:item.ftp.url="{ item }">
                    <span @click="doCopy($event)">{{ item.ftp.url }}</span>
                  </template>

                  <template v-slot:item.ftp.user="{ item }">
                    <span @click="doCopy($event)">{{ item.ftp.user }}</span>
                  </template>

                  <template v-slot:item.ftp.password="{ item }">
                    <span @click="doCopy($event)">{{ item.ftp.password }}</span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn class="ma-2" outlined x-small fab @click="editDomainPopUp(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-dialog v-model="dialogEditDomain" max-width="1200" style="width:90%">
      <v-card>
        <v-banner color="transparent" single-line>
          <span class="title">Info</span>
          <template v-slot:actions>
            <span class="caption">to change values unlock the form</span>
            <v-switch v-model="switchEdit" inset></v-switch>
            <v-btn class="ma-2" outlined x-small fab type="submit" @click="saveDomain">
              <v-icon>mdi-floppy</v-icon>
            </v-btn>
          </template>
        </v-banner>
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="6" sm="6" md="6">
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>
                    <v-text-field
                      label="Domain"
                      hide-details="auto"
                      v-model="newDomain.domain"
                      outlined
                      placeholder="Domain"
                      :disabled="switchEdit == false"
                    ></v-text-field>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>Backoffice</v-card-title>
                  <v-card-text>
                    <div>
                      <v-text-field
                        label="Backoffice URL"
                        hide-details="auto"
                        v-model="newDomain.backoffice.url"
                        outlined
                        placeholder="Backoffice URL"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="Backoffice User"
                        hide-details="auto"
                        v-model="newDomain.backoffice.user"
                        outlined
                        placeholder="Backoffice User"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="Backoffice Password"
                        hide-details="auto"
                        v-model="newDomain.backoffice.password"
                        outlined
                        placeholder="Backoffice Password"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>cPanel</v-card-title>
                  <v-card-text>
                    <div>
                      <v-text-field
                        label="cPanel URL"
                        hide-details="auto"
                        v-model="newDomain.cPanel.url"
                        outlined
                        placeholder="cPanel URL"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="cPanel User"
                        hide-details="auto"
                        v-model="newDomain.cPanel.user"
                        outlined
                        placeholder="cPanel User"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="cPanel Password"
                        hide-details="auto"
                        v-model="newDomain.cPanel.password"
                        outlined
                        placeholder="cPanel Password"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>FTP</v-card-title>
                  <v-card-text>
                    <div>
                      <v-text-field
                        label="FTP URL"
                        hide-details="auto"
                        v-model="newDomain.ftp.url"
                        outlined
                        placeholder="FTP URL"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="FTP User"
                        hide-details="auto"
                        v-model="newDomain.ftp.user"
                        outlined
                        placeholder="FTP User"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                    <div style="margin:20px 0px">
                      <v-text-field
                        label="FTP Password"
                        hide-details="auto"
                        v-model="newDomain.ftp.password"
                        outlined
                        placeholder="FTP Password"
                        :disabled="switchEdit == false"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="pa-3">
                <v-card>
                  <v-card-title>Miscellaneous</v-card-title>
                  <v-card-text>
                    <v-textarea
                      outlined
                      v-model="newDomain.observations"
                      placeholder="Observations"
                      label="Observations"
                      :disabled="switchEdit == false"
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import store from "@/store";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "domainlistbackoffice",
  data() {
    return {
      tab: null,
      dialogEditDomain: false,
      searchBackoffice: "",
      searchFtp: "",
      headersBackoffice: [
        {
          text: "Domain",
          align: "left",
          sortable: false,
          value: "domain"
        },
        { text: "Backoffice URL", value: "backoffice.url" },
        { text: "Backoffice User", value: "backoffice.user" },
        { text: "Backoffice Password", value: "backoffice.password" },
        { text: "Actions", value: "action", sortable: false }
      ],
      headersFtp: [
        {
          text: "Domain",
          align: "left",
          sortable: false,
          value: "domain"
        },
        { text: "FTP URL", value: "ftp.url" },
        { text: "FTP User", value: "ftp.user" },
        { text: "FTP Password", value: "ftp.password" },
        { text: "Actions", value: "action", sortable: false }
      ],
      newDomain: this.createEmptyDomain(),
      switchEdit: false
    };
  },
  computed: {
    ...mapGetters(["getDomains"])
  },
  filters: {
    covertToArray(array) {
      let tempArray = [];
      for (let index in array) {
        tempArray.push(array[index]);
      }
      return tempArray;
    }
  },
  methods: {
    ...mapActions(["editDomain"]),
    doCopy(value) {
      this.$copyText(value.target.innerHTML).then(
        function() {
          const notification = {
            type: "success",
            message: "Text copied to clipboard!"
          };
          store.dispatch("notification/add", notification, {
            root: true
          });
        },
        function() {
          const notification = {
            type: "error",
            message: "Error copying to clipboard"
          };
          store.dispatch("notification/add", notification, {
            root: true
          });
        }
      );
    },
    editDomainPopUp(item) {
      this.newDomain = { ...item };
      this.dialogEditDomain = true;
    },
    saveDomain() {
      this.editDomain(this.newDomain);
      this.dialogEditDomain = false;
    },
    openNew(value) {
      window.open(value.target.innerHTML, "_blank");
    },
    createEmptyDomain() {
      return {
        domain: null,
        backoffice: {
          url: null,
          user: null,
          password: null
        },
        ftp: {
          url: null,
          user: null,
          password: null
        },
        cPanel: {
          url: null,
          user: null,
          password: null
        },
        observations: null,
        creationDate: null
      };
    }
  }
};
</script>

<style>
.pointer-cursor {
  cursor: pointer;
}
</style>
